const pageViewEvents = {
  action: "page-view",
  labels: {
    dashboard: {
      guest: "dashboard:guest",
      loggedIn: "dashboard:logged-in",
    },
    createRoomPage: {
      guest: "create-room-page:guest",
      loggedIn: "create-room-page:logged-in",
    },
    roomPage: {
      guest: "room-page:guest",
      loggedIn: "room-page:logged-in",
    },
    loginSplash: {
      guest: "login-splash:guest",
      loggedIn: "login-splash:logged-in",
    },
  },
};

export default pageViewEvents;
